export var getStyles = function getStyles(props) {
  var className = props.className,
      theme = props.theme;
  var palette = theme.palette;
  return {
    root: [theme.fonts.medium, 'ms-CommandBar', {
      display: 'flex',
      backgroundColor: palette.neutralLighter,
      padding: '0 16px',
      height: '40px'
    }, className],
    primarySet: ['ms-CommandBar-primaryCommand', {
      flexGrow: '1',
      display: 'flex',
      alignItems: 'stretch'
    }],
    secondarySet: ['ms-CommandBar-secondaryCommand', {
      flexShrink: '0',
      display: 'flex',
      alignItems: 'stretch'
    }]
  };
};